import { UbigeoState } from '../../shared/layer/ubigeo/ubigeo-state';

/**
 * Campos ubigeo de SERFOR. Los códigos son jerárquicos (departamento 2 dígitos,
 * provincia 4, distrito 6), así que el nivel se deduce del largo del código y no
 * hace falta preguntar cuál se seleccionó.
 */
const DEPT_FIELD = 'CATDEP';
const PROV_FIELD = 'CATPRO';
const DIST_FIELD = 'CATDIS';

/** Ámbito territorial resuelto a partir del ubigeo del header. */
export interface FireScope {
  /** Código vigente del nivel más específico (null = nacional). */
  code: string | null;
  /** Etiqueta pública del ámbito ("Nacional", "LIMA", "CURAHUASI"…). */
  label: string;
  /**
   * Filtro equivalente para las fuentes SERFOR: sirve igual como `where` de una
   * consulta REST y como `definitionExpression` del mapa. Cadena vacía = sin
   * filtro (ámbito nacional).
   */
  expression: string;
}

/**
 * Traduce el ubigeo del header al ámbito de los incendios forestales.
 *
 * Fuente única de verdad para el KPI del header y para el filtro de las capas
 * del mapa: si cada uno dedujera el nivel por su cuenta podrían mostrar ámbitos
 * distintos ante la misma selección.
 */
export function resolveFireScope(ub: UbigeoState): FireScope {
  // Ámbito = el nivel más específico seleccionado (distrito > provincia > dpto).
  const code = ub.selectedDistrict || ub.selectedProvince || ub.selectedDepartment || null;

  const label = ub.selectedDistrict
    ? ub.selectedDistrictName
    : ub.selectedProvince
      ? ub.selectedProvinceName
      : ub.selectedDepartment
        ? ub.selectedDepartmentName
        : 'Nacional';

  return { code, label, expression: expressionFor(code) };
}

/** `where` del ámbito; cadena vacía cuando no hay selección (todo el país). */
export function expressionFor(code: string | null): string {
  if (!code) return '';
  if (code.length >= 6) return `${DIST_FIELD} = '${code}'`;
  if (code.length === 4) return `${PROV_FIELD} = '${code}'`;
  return `${DEPT_FIELD} = '${code}'`;
}
